import React from 'react';
import { Dice1Icon, Dice6, Gift, Plane, Rocket, Star, Wallet } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import MinesIcon from '../../../assets/mines.png';
import AviatorIcon from '../../../assets/aviator.png';
import CricketIcon from '../../../assets/cricchallange.png';
import SpinIcon from '../../../assets/icon-roulette.be0624e.png'

const choices = [
    {
        name: "Mines",
        // icon: <Star className="w-6 h-6 text-yellow-400" />,
        icon: (<div>
            <img src={MinesIcon} width={30} />
        </div>),
        href: "/mines"
    },
    {
        name: "Aviator",
        // icon: <Plane className="w-6 h-6 text-red-400" />,
        icon: (<div>
            <img src={AviatorIcon} className='h-[35px]' />
        </div>),
        href: "/aviator"
    },
    {
        name: "Live Casino",
        // icon: (<div>
        //     <img src={CasinoIcon} />
        // </div>),
        icon: <Dice6 />,
        href: "/live-casino"
    },
    {
        name: "JetX",
        icon: <Rocket className="w-6 h-6 text-blue-400" />,
        href: "/jetx"
    },
    {
        name: "Cricket Exchange",
        icon: (
            <div>
                <img
                    src={CricketIcon}
                    alt=""
                    width={90}
                    height={30}
                />
            </div>
        ),
        href: "/cricket"
    },
    {
        name: "Lucky Spin",
        icon: (
            <div className="relative w-6 h-6">
                <img
                    src={SpinIcon}
                    alt=""
                    className="object-contain"
                />
            </div>
        ),
        href: "/lucky-spin"
    },
    {
        name: "Bonus",
        icon: <Gift className="w-6 h-6 text-purple-400" />,
        href: "/bonus"
    },
    {
        name: "Deposit",
        icon: <Wallet className="w-6 h-6 text-blue-400" />,
        href: "/deposit"
    }
]
export default function TopChoicesNav() {
    const navigate = useNavigate();

    const onClickChoices = (path) => {
        navigate(path);
    }

    return (
        <div className="w-full py-6">
            <div className="flex items-center gap-2 mb-4">
                <div className="text-yellow-400">🏆</div>
                <h2 className="text-lg font-bold bg-gradient-to-t from-[#009ae5] to-[#46c2ff] bg-clip-text text-transparent">Top Choices</h2>
            </div>
            {/* <div className="overflow-x-auto pb-4"> */}
            <div className="gap-[17px] grid grid-cols-4 md:grid-cols-8 w-full">
                {choices.map((choice) => (
                    <button
                        key={choice.name}
                        onClick={() => onClickChoices(choice.path)}
                        className="flex flex-col items-center justify-center p-4 rounded-lg bg-gradient-to-b from-[#242c45] to-[#141929] hover:scale-105 hover:ease-in-out duration-500"
                    >
                        {/* <div className='flex flex-col items-center justify-center'> */}
                        <div className="mb-2">{choice.icon}</div>
                        <span className="text-sm text-white font-medium text-center">
                            {choice.name}
                        </span>
                        {/* </div> */}
                    </button>
                ))}
            </div>
            {/* </div> */}
        </div>
    )
}

